/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Table_TitleInputs */

const en_carrier_notices_table_title = /** @type {(inputs: Carrier_Notices_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier notice status`)
};

const es_carrier_notices_table_title = /** @type {(inputs: Carrier_Notices_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de avisos de transportistas`)
};

/**
* | output |
* | --- |
* | "Carrier notice status" |
*
* @param {Carrier_Notices_Table_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_table_title = /** @type {((inputs?: Carrier_Notices_Table_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Table_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_table_title(inputs)
	return es_carrier_notices_table_title(inputs)
});